import type { FC } from 'react';

import { Typography } from 'enable-ui';

import { ReactComponent as AvatarIcon } from 'assets/icons/avatar.svg';

import { COLOR } from 'constants/color';

export const InfoComp: FC<{ avatar: string; name: string }> = ({ avatar, name }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <div>
        {avatar ? (
          <img
            src={avatar}
            alt="avatar"
            style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' }}
          />
        ) : (
          <AvatarIcon style={{ width: 32, height: 32 }} />
        )}
      </div>
      <Typography
        color={COLOR.surfaceNeutralBold['neutral-11']}
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '367px',
        }}
      >
        {name}
      </Typography>
    </div>
  );
};
